module.exports = __webpack_public_path__ + "media/images/application/tax-d36ea1c9ebc198dc3c66a4af19cd829a.jpg";